import React from "react";
import PropTypes from "prop-types";
import SectionHeader from "./SectionHeader";
import Input from "../util/Input";
import Select from "../util/Select";

// "Contact Details" section of the Figma form
const PrimaryContact = (props) => {
  let emailStatus;
  let emailError;
  let emailHelp = "Please register with your corporate email address.";
  if (props.emailValidationBlocked) {
    emailStatus = "error";
    emailError = "Please register with your corporate email address.";
  } else if (props.emailValidationWrong) {
    emailStatus = "error";
    emailError = "Please provide a valid email address.";
  } else if (props.emailValidationLoading) {
    emailHelp = "Validating email address...";
  } else if (props.emailValidationCheck) {
    emailStatus = "success";
  }

  return (
    <div className='AppSection regSection'>
      <SectionHeader title={"Contact Details"} showHr={false} />

      <div className='regRow regRow--2'>
        <Input
          labelText='First Name'
          placeholder='Enter first name'
          isRequired={true}
          onChange={props.handleFirstNameChange}
          value={props.firstName}
          readOnly={props.lockFirstName}
          maximumLength={35}
        />
        <Input
          labelText='Last Name'
          placeholder='Enter last name'
          isRequired={true}
          onChange={props.handleLastNameChange}
          value={props.lastName}
          readOnly={props.lockLastName}
          maximumLength={35}
        />
      </div>
      <Input
        labelText='Email Address'
        placeholder='Enter email address'
        isRequired={true}
        onChange={props.handleEmailChange}
        onBlur={props.handleEmailBlur}
        value={props.emailAddress}
        readOnly={props.lockEmail}
        maximumLength={80}
        status={emailStatus}
        errorText={emailError}
        helpText={emailHelp}
      />
      <Input
        labelText='Confirm Email Address'
        placeholder='Confirm email address'
        isRequired={true}
        onChange={props.handleEmailChangeConfirm}
        value={props.emailAddressConfirm}
        readOnly={props.lockEmail}
        maximumLength={80}
        onPaste={props.handleEmailConfirmPaste}
      />
      <div className='regRow regRow--2'>
        <Input
          labelText='Phone'
          placeholder='Enter phone number'
          isRequired={true}
          value={props.phone}
          onChange={props.handlePhoneChange}
          maximumLength={35}
        />
        <Select
          labelText='Job Role'
          optionValues={props.jobRoles}
          isRequired={true}
          value={props.jobRole}
          onChange={props.handleJobRoleChange}
        />
      </div>
    </div>
  );
};

PrimaryContact.propTypes = {
  jobRole: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  IsRWA03: PropTypes.bool,
  handleEmailChange: PropTypes.func.isRequired,
  handleEmailChangeConfirm: PropTypes.func.isRequired,
  handleEmailConfirmPaste: PropTypes.func.isRequired,
  handleEmailBlur: PropTypes.func.isRequired,
  handleFirstNameChange: PropTypes.func.isRequired,
  handleLastNameChange: PropTypes.func.isRequired,
  handlePhoneChange: PropTypes.func.isRequired,
  handleJobRoleChange: PropTypes.func.isRequired,
  emailAddressConfirm: PropTypes.string,
  emailAddress: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  phone: PropTypes.string,
  jobRoles: PropTypes.array.isRequired,
  lockEmail: PropTypes.bool.isRequired,
  lockFirstName: PropTypes.bool.isRequired,
  lockLastName: PropTypes.bool.isRequired,
  emailValidationLoading: PropTypes.bool,
  emailValidationCheck: PropTypes.bool,
  emailValidationWrong: PropTypes.bool,
  emailValidationBlocked: PropTypes.bool
};

export default PrimaryContact;
